import {
    GET_ACADEMIC_YEARS_FAIL,
    GET_ACADEMIC_YEARS_SUCCESS,
    ADD_ACADEMIC_YEAR_SUCCESS,
    ADD_ACADEMIC_YEAR_FAIL,
    UPDATE_ACADEMIC_YEAR_SUCCESS,
    UPDATE_ACADEMIC_YEAR_FAIL,
    DELETE_ACADEMIC_YEAR_SUCCESS,
    DELETE_ACADEMIC_YEAR_FAIL,

    GET_ACTIVE_ACADEMIC_YEARS,
    GET_ACTIVE_ACADEMIC_YEARS_SUCCESS,
    GET_ACTIVE_ACADEMIC_YEARS_FAIL,
    
} from "./actionTypes";

const INIT_STATE = {
    academicYears: [],
    activeAcademicYears: [],
    error: null,
    loading: true
};

const academicYearReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des departments
        case GET_ACADEMIC_YEARS_SUCCESS:
            return {
                ...state,
                academicYears: action.payload, // tableau d'objets branch
                loading: false,
                error: null
            };

        case GET_ACADEMIC_YEARS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une department
        case ADD_ACADEMIC_YEAR_SUCCESS:
            return {
                ...state,
                academicYears: [action.payload, ...state.academicYears], // ajoute au début du tableau
                error: null
            };

        case ADD_ACADEMIC_YEAR_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une department
        case UPDATE_ACADEMIC_YEAR_SUCCESS:
            return {
                ...state,
                academicYears: state.academicYears.map(academicYear =>
                    academicYear.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet branch
                        : academicYear
                ),
                error: null
            };

        case UPDATE_ACADEMIC_YEAR_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une department
        case DELETE_ACADEMIC_YEAR_SUCCESS:
            return {
                ...state,
                academicYears: state.academicYears.filter(
                    academicYear => academicYear.id !== action.payload
                ),
                error: null
            };


        case DELETE_ACADEMIC_YEAR_FAIL:
            return {
                ...state,
                error: action.payload
            };


        case GET_ACTIVE_ACADEMIC_YEARS:
            return { ...state, loading: true };

        case GET_ACTIVE_ACADEMIC_YEARS_SUCCESS:
            return { 
                ...state, 
                activeAcademicYears: action.payload, 
                loading: false 
            };

        case GET_ACTIVE_ACADEMIC_YEARS_FAIL:
            return { 
                ...state, 
                error: action.payload, 
                loading: false 
            };

        default:
            return state;
    }
};

export default academicYearReducer;
